import { userApi as api } from "../../utils/apiInstances";

// Function to handle user financial request
export const handleUserFinancialDonation = async (
    userData: unknown,
    onSuccess: (res: unknown) => void,
    onError?: (err: unknown) => void
) => {
    try {
        const response = await api("POST", "/user/donate", userData);
        onSuccess(response);
    } catch (error) {
        if (onError) {
            onError(error);
        }
    }
};
